var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lr-dialog',{attrs:{"dialogTitle":"个人信息","dialogVisible":_vm.visible,"width":"600px","closeSubmit":true},on:{"update:dialogVisible":function($event){_vm.visible=$event},"update:dialog-visible":function($event){_vm.visible=$event}}},[_c('user-detail',{attrs:{"UserID":_vm.UserID}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ec48ca2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/UserDetailDialog.vue
// module id = null
// module chunks = 